import { render, staticRenderFns } from "./bannerBox.vue?vue&type=template&id=11d6d350&"
import script from "./bannerBox.vue?vue&type=script&lang=js&"
export * from "./bannerBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports